import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostOrtCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostOrtCommandService],
  exports: []
})
export class PostOrtCommandServiceModule { }
